function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useEventReporter, useStore, useStoreActions, useIoContext } from "../contexts";
import { selectors } from "../store/state-selectors";
import { useDidUpdate, useStateInRef } from 'seagull';
export default function AuthProvider(_ref) {
  let {
    children
  } = _ref;
  const authToken = useStore(state => state.authToken);
  const userInfo = useStore(state => state.userInfo);
  const impersonatingAs = useStore(selectors.impersonatingAs);
  const intercomUserHash = useStore(selectors.intercomUserHash);
  const {
    reset: resetStore
  } = useStoreActions();
  const {
    getIntercom,
    getHotjar,
    cookies
  } = useIoContext();
  const bi = useEventReporter();
  const getBI = useStateInRef(bi);
  useDidUpdate(() => {
    if (authToken == null) {
      cookies.setCookie('AuthToken', '', {
        expires: new Date(0)
      });
      cookies.trySignalAuthTokenChange();
      resetStore(true);
    }
  }, [authToken]);
  useEffect(() => {
    if (!(userInfo !== null && userInfo !== void 0 && userInfo.id) || impersonatingAs) {
      getBI().resetIdentity();
      getIntercom()('shutdown');
      return;
    }
    Sentry.setUser({
      id: userInfo.id
    }); //For future reference - the reason we're not sending user email is because of GDPR reasons

    const {
      id,
      email,
      firstName,
      lastName,
      phone,
      numClientsAMonth,
      referredBy,
      worksAt
    } = userInfo;
    const {
      hasLinkedBankAccount,
      invitedUserCount,
      membersCount,
      ownership,
      kycCompletionStatus,
      businessTypes,
      csm,
      postalAddress,
      numSaleAgreements,
      numPurchaseAgreements,
      numSaleInvoices,
      numPurchaseInvoices,
      numSampleAgreements,
      role,
      features
    } = worksAt || {};
    const userProperties = _objectSpread({
      id,
      firstName,
      lastName,
      phone,
      numClientsAMonth,
      accountsReceivable: features === null || features === void 0 ? void 0 : features.accountsReceivable,
      accountsPayable: features === null || features === void 0 ? void 0 : features.accountsPayable,
      hasLinkedBankAccount,
      invitedUserCount,
      membersCount,
      ownership,
      kycCompletionStatus,
      numSaleAgreementsApproved: numSaleAgreements === null || numSaleAgreements === void 0 ? void 0 : numSaleAgreements.approved,
      numSaleAgreementsPending: numSaleAgreements === null || numSaleAgreements === void 0 ? void 0 : numSaleAgreements.pending,
      numPurchaseAgreementsApproved: numPurchaseAgreements === null || numPurchaseAgreements === void 0 ? void 0 : numPurchaseAgreements.approved,
      numPurchaseAgreementsPending: numPurchaseAgreements === null || numPurchaseAgreements === void 0 ? void 0 : numPurchaseAgreements.pending,
      numSaleInvoicesPaid: numSaleInvoices === null || numSaleInvoices === void 0 ? void 0 : numSaleInvoices.paid,
      numSaleInvoicesPending: numSaleInvoices === null || numSaleInvoices === void 0 ? void 0 : numSaleInvoices.pending,
      numPurchaseInvoicesPaid: numPurchaseInvoices === null || numPurchaseInvoices === void 0 ? void 0 : numPurchaseInvoices.paid,
      numPurchaseInvoicesPending: numPurchaseInvoices === null || numPurchaseInvoices === void 0 ? void 0 : numPurchaseInvoices.pending,
      numSampleAgreementsApproved: numSampleAgreements === null || numSampleAgreements === void 0 ? void 0 : numSampleAgreements.approved,
      numSampleAgreementsPending: numSampleAgreements === null || numSampleAgreements === void 0 ? void 0 : numSampleAgreements.pending,
      businessTypes,
      referredBy: referredBy === null || referredBy === void 0 ? void 0 : referredBy.businessId,
      csm,
      role
    }, postalAddress);
    getBI().identify(id, email, userProperties);
    getIntercom()('boot', {
      app_id: window._intercom_app_id,
      email,
      user_id: id,
      created_at: Date.now(),
      user_hash: intercomUserHash || undefined
    });
    getHotjar().identify(userInfo.id, _objectSpread({
      sessionId: window._sessionId
    }, userProperties));
  }, [userInfo, intercomUserHash, impersonatingAs]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}